// import moment from 'moment-timezone';

// import { G, ajax } from '@/_common';
// import { useStore } from '@/store';

// const store = useStore();

export const Services = {
    getWData: async () => {
        // await ajax({
        //     url: store.getWarningsData(),
        //     method: "get",
        //     success: async (xx) => {
        //         let res = xx.data || null;
        //         if ( xx.status == 200 && res ) {
        //             res.forEach(r => {
        //                 let a = JSON.parse(r.data);
        //                 G.alert.info({
        //                     html: `${a.title} <br /> ${a.sub_title} <br /> ${moment.utc(r.warning_date).tz(G.systemData?.timezone?.value).format(G.datetime_format['datetime'])}`,
        //                     life: 0,
        //                     toast: true,
        //                     position: 'top-end',
        //                     class: 'mt-5',
        //                 });
        //             });
        //             // router.replace({name: "melumat_banki"});
        //         }
        //     },
        // });
    },


    // addCountry: (source_var) => {
    //     let TR = store.getTranslation();
    // },

    // source_var.push({"value": res.id, "label": res.name});

}
